import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  openCard: ['data'],
  setCardId: ['id'],
  updateCard: ['id'],
});

const INITIAL_STATE: {
  id?: number;
  protocolNumber?: number;
  responsibleGroup?: string;
  ticketId?: string;
  ticketReason?: string;
  ticketDevolution?: {
    [key: string]: any;
  };
  ticketCorrectionLetter?: {
    [key: string]: any;
  };
  state?: {
    [key: string]: any;
  };
} = {
  id: undefined,
  protocolNumber: undefined,
  responsibleGroup: undefined,
  ticketId: undefined,
  state: {},
};

// eslint-disable-next-line no-unused-vars
const openCard = (_state = INITIAL_STATE, action: any) => ({ ...action.data });

const setCard = (state = INITIAL_STATE, action: any) => ({
  ...state,
  id: action.id,
  protocolNumber: action.protocolNumber,
  responsibleGroup: action.responsibleGroup,
  ticketId: action.ticketId,
});

const updateCard = (state = INITIAL_STATE, action: any) => ({
  ...state,
  ticketDevolution: action.ticketDevolution
});

export default createReducer(INITIAL_STATE, {
  [Types.OPEN_CARD as any]: openCard,
  [Types.SET_CARD_ID as any]: setCard,
  [Types.UPDATE_CARD as any]: updateCard,
});
